module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vrepr12-5cc2e8eaf7eaf2c5d0ae2a96e9d04982.jpg";